import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line id-length
import { formatLabel } from '../../../../../../src/web/utils/labelFormatter';
import CurrentUserLocationIntlPhoneInput from '../../../../../containers/CurrentUserLocationIntlPhoneInput';
import styles from './CreateLeadModal.scss';

const propTypes = {
  handleSubmit: PropTypes.func,
  updatePhone: PropTypes.func.isRequired,
  fieldFont: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  formError: PropTypes.bool,
};

const defaultProps = {
  handleSubmit: undefined,
  firstName: undefined,
  lastName: undefined,
  phoneNumber: undefined,
  email: undefined,
  formError: undefined,
};

const CreateLeadForm = ({
  handleSubmit,
  updatePhone,
  fieldFont,
  onChange,
  firstName,
  lastName,
  phoneNumber,
  email,
  formError,
}) => {
  const phoneInputId = 'createLeadForm-phone';
  return (
    <form onSubmit={handleSubmit} className={styles.leadForm}>
      <label htmlFor="firstName">
        {formatLabel('widgets.unitstable.leadform.firstname', 'first name')}
      </label>
      <input
        id="firstName"
        className={formError && !firstName.length ? styles.error : styles.input}
        onChange={e => onChange(e)}
        placeholder="John"
        value={firstName}
        type="text"
        name="firstName"
      />
      <label htmlFor="lastName">
        {formatLabel('widgets.unitstable.leadform.lastname', 'last name')}
      </label>
      <input
        id="lastName"
        className={formError && !lastName.length ? styles.error : styles.input}
        onChange={e => onChange(e)}
        placeholder="Doe"
        value={lastName}
        type="text"
        name="lastName"
      />
      <label htmlFor="email">
        {formatLabel('widgets.unitstable.leadform.email', 'email')}
      </label>
      <input
        id="email"
        className={formError && !email.length ? styles.error : styles.input}
        onChange={e => onChange(e)}
        placeholder="hello@email.com"
        value={email}
        type="text"
        name="email"
      />
      <label htmlFor={phoneInputId}>
        {formatLabel('widgets.unitstable.leadform.phone', 'phone number')}
      </label>
      <CurrentUserLocationIntlPhoneInput
        fieldName={phoneInputId}
        id={phoneInputId}
        value={phoneNumber}
        onPhoneChange={updatePhone}
        wrapperClassName={styles.intlPhoneInput}
        style={{ fontFamily: fieldFont }}
        inputClassName={formError && !phoneNumber.length ? styles.error : styles.input}
      />
    </form>
  );
};

CreateLeadForm.propTypes = propTypes;
CreateLeadForm.defaultProps = defaultProps;

export default CreateLeadForm;
